/* eslint-disable */
const SearchIcon = (props) => {
  return (
    <svg
      {...props}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.57269 1.94874C4.91368 1.94874 1.94874 4.91132 1.94874 8.56427C1.94874 12.2173 4.91368 15.1799 8.57269 15.1799C10.3981 15.1799 12.0499 14.4432 13.2486 13.25C14.4528 12.0514 15.1966 10.3952 15.1966 8.56427C15.1966 4.91132 12.2317 1.94874 8.57269 1.94874ZM0.666687 8.56427C0.666687 4.20186 4.20701 0.666687 8.57269 0.666687C12.9384 0.666687 16.4787 4.20186 16.4787 8.56427C16.4787 10.5188 15.7673 12.3081 14.5903 13.6867L17.1454 16.2388C17.3959 16.489 17.396 16.8949 17.1459 17.1454C16.8957 17.3959 16.4898 17.396 16.2394 17.1459L13.6819 14.5914C12.3042 15.7578 10.5202 16.4619 8.57269 16.4619C4.20701 16.4619 0.666687 12.9267 0.666687 8.56427Z"
        fill="#7C7C7C"
      />
    </svg>
  )
}
const LangArrows = (props) => {
  return (
    <svg
      {...props}
      width="11"
      height="6"
      viewBox="0 0 11 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 1L5.5 5L9.5 1"
        stroke="#7C7C7C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
const Menu = (props) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 7H21"
        stroke="#201B1C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3 12H21"
        stroke="#201B1C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3 17H21"
        stroke="#201B1C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
const Close = (props) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.63599 6L18.3639 18.7279"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M5.63599 19L18.3639 6.27208"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
const RightArrow = (props) => {
  return (
    <svg
      {...props}
      width="7"
      height="10"
      viewBox="0 0 7 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.50001 4.99999C6.50001 5.25599 6.40201 5.51199 6.20701 5.70699L2.20701 9.70699C1.81601 10.098 1.18401 10.098 0.793006 9.70699C0.402006 9.31599 0.402006 8.68399 0.793006 8.29299L4.09801 4.98799L0.918005 1.69499C0.535005 1.29599 0.546005 0.664994 0.943005 0.280994C1.34001 -0.103005 1.97401 -0.0920058 2.35701 0.304995L6.21901 4.30499C6.40701 4.49999 6.50001 4.74999 6.50001 4.99999Z"
        fill="#2E3A59"
      />
    </svg>
  )
}
const BackArrow = (props) => {
  return (
    <svg
      {...props}
      width="7"
      height="14"
      viewBox="0 0 7 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.59065e-05 7C1.59165e-05 6.772 0.0770156 6.545 0.232016 6.36L5.23202 0.360001C5.58502 -0.0639994 6.21602 -0.121999 6.64002 0.232001C7.06402 0.585001 7.12102 1.215 6.76802 1.64L2.29202 7.011L6.60702 12.373C6.95302 12.803 6.88502 13.433 6.45502 13.779C6.02502 14.125 5.39602 14.057 5.04902 13.627L0.221016 7.627C0.0740162 7.444 1.58968e-05 7.222 1.59065e-05 7Z"
        fill="#2E3A59"
      />
    </svg>
  )
}
const ButtonArrow = () => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 8H12.865L9.232 12.36C8.878 12.784 8.936 13.415 9.36 13.768C9.785 14.122 10.415 14.064 10.769 13.64L15.769 7.64C15.808 7.593 15.827 7.538 15.856 7.486C15.88 7.444 15.909 7.408 15.927 7.362C15.972 7.247 15.999 7.126 15.999 7.004C15.999 7.003 16 7.001 16 7C16 6.999 15.999 6.997 15.999 6.996C15.999 6.874 15.972 6.753 15.927 6.638C15.909 6.592 15.88 6.556 15.856 6.514C15.827 6.462 15.808 6.407 15.769 6.36L10.769 0.36C10.57 0.123 10.286 0 10 0C9.774 0 9.547 0.076 9.36 0.232C8.936 0.585 8.878 1.216 9.232 1.64L12.865 6H1C0.448 6 0 6.448 0 7C0 7.552 0.448 8 1 8Z"
        fill="#166FE5"
      />
    </svg>
  )
}
const PlayIcon = (props) => {
  return (
    <svg
      {...props}
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2324 6.45677C12.899 6.84167 12.899 7.80392 12.2324 8.18882L2.18118 13.9919C1.51452 14.3768 0.68118 13.8956 0.68118 13.1258L0.681181 1.51975C0.681181 0.749945 1.51451 0.268818 2.18118 0.653718L12.2324 6.45677Z"
        fill="#2E3A59"
      />
    </svg>
  )
}
const CopyRight = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 9C13.9948 8.49083 13.3718 8.15907 12.7058 8.04453C12.0397 7.92999 11.3588 8.03753 10.7449 8.35425C10.131 8.67097 9.61011 9.18342 9.24472 9.83009C8.87932 10.4768 8.68497 11.2302 8.68497 12C8.68497 12.7698 8.87932 13.5232 9.24472 14.1699C9.61011 14.8166 10.131 15.329 10.7449 15.6458C11.3588 15.9625 12.0397 16.07 12.7058 15.9555C13.3718 15.8409 13.9948 15.5092 14.5 15"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
const fbIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" fill="#43538E" />
      <path
        d="M16 7.6665C11.3975 7.6665 7.66663 11.3973 7.66663 15.9998C7.66663 20.159 10.7141 23.6065 14.6983 24.2323V18.4082H12.5816V15.9998H14.6983V14.164C14.6983 12.0757 15.9416 10.9223 17.8458 10.9223C18.7575 10.9223 19.7108 11.0848 19.7108 11.0848V13.1348H18.6608C17.625 13.1348 17.3025 13.7773 17.3025 14.4365V15.9998H19.6133L19.2441 18.4082H17.3025V24.2323C21.2858 23.6073 24.3333 20.1582 24.3333 15.9998C24.3333 11.3973 20.6025 7.6665 16 7.6665Z"
        fill="white"
      />
    </svg>
  )
}
const liIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" fill="#4C76B5" />
      <path
        d="M21.2792 21.2825H19.0583V17.8017C19.0583 16.9717 19.0417 15.9033 17.9 15.9033C16.7425 15.9033 16.5658 16.8067 16.5658 17.7408V21.2825H14.3442V14.125H16.4775V15.1H16.5067C16.805 14.5383 17.53 13.9442 18.6133 13.9442C20.8633 13.9442 21.28 15.4258 21.28 17.3533V21.2825H21.2792ZM11.8358 13.1458C11.6663 13.1461 11.4984 13.1128 11.3417 13.048C11.1851 12.9832 11.0427 12.8881 10.9229 12.7682C10.803 12.6483 10.708 12.5059 10.6433 12.3492C10.5786 12.1925 10.5455 12.0245 10.5458 11.855C10.546 11.5999 10.6218 11.3505 10.7637 11.1385C10.9056 10.9264 11.1072 10.7612 11.3429 10.6637C11.5787 10.5662 11.8381 10.5408 12.0883 10.5908C12.3385 10.6407 12.5683 10.7637 12.7486 10.9443C12.9289 11.1248 13.0516 11.3547 13.1012 11.605C13.1508 11.8553 13.1251 12.1146 13.0273 12.3503C12.9295 12.5859 12.7641 12.7873 12.5518 12.9289C12.3396 13.0705 12.0901 13.146 11.835 13.1458H11.8358ZM12.9492 21.2825H10.7217V14.125H12.95V21.2825H12.9492ZM22.3917 8.5H9.6075C8.99417 8.5 8.5 8.98333 8.5 9.58083V22.4192C8.5 23.0167 8.995 23.5 9.60667 23.5H22.3883C23 23.5 23.5 23.0167 23.5 22.4192V9.58083C23.5 8.98333 23 8.5 22.3883 8.5H22.3908H22.3917Z"
        fill="white"
      />
    </svg>
  )
}
const ytIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" fill="#CA564A" />
      <path
        d="M23.9525 11.4152C24.3333 12.9002 24.3333 16.0002 24.3333 16.0002C24.3333 16.0002 24.3333 19.1002 23.9525 20.5852C23.7408 21.406 23.1216 22.0518 22.3375 22.2702C20.9133 22.6668 16 22.6668 16 22.6668C16 22.6668 11.0891 22.6668 9.66246 22.2702C8.87496 22.0485 8.25663 21.4035 8.04746 20.5852C7.66663 19.1002 7.66663 16.0002 7.66663 16.0002C7.66663 16.0002 7.66663 12.9002 8.04746 11.4152C8.25913 10.5943 8.87829 9.9485 9.66246 9.73016C11.0891 9.3335 16 9.3335 16 9.3335C16 9.3335 20.9133 9.3335 22.3375 9.73016C23.125 9.95183 23.7433 10.5968 23.9525 11.4152ZM14.3333 18.9168L19.3333 16.0002L14.3333 13.0835V18.9168Z"
        fill="white"
      />
    </svg>
  )
}
const Article = (props) => {
  return (
    <svg
      {...props}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 26H18M26 6H32C32.5304 6 33.0391 6.21071 33.4142 6.58579C33.7893 6.96086 34 7.46957 34 8V30C34 31.0609 33.5786 32.0783 32.8284 32.8284C32.0783 33.5786 31.0609 34 30 34C28.9391 34 27.9217 33.5786 27.1716 32.8284C26.4214 32.0783 26 31.0609 26 30V4C26 3.46957 25.7893 2.96086 25.4142 2.58579C25.0391 2.21071 24.5304 2 24 2H4C3.46957 2 2.96086 2.21071 2.58579 2.58579C2.21071 2.96086 2 3.46957 2 4V28C2 29.5913 2.63214 31.1174 3.75736 32.2426C4.88258 33.3679 6.4087 34 8 34H30L26 6ZM10 10H18H10ZM10 18H18H10Z"
        stroke="#C5CEE0"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
const Post = (props) => {
  return (
    <svg
      {...props}
      width="42"
      height="44"
      viewBox="0 0 42 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 20V8C36 5.8 34.2 4 32 4H30V0H26V4H10V0H6V4H4C1.8 4 0 5.8 0 8V36C0 38.2 1.8 40 4 40H18V36H4V16H32V20H36ZM25.28 36C25.7633 37.6099 26.8092 38.9924 28.2269 39.8955C29.6446 40.7986 31.3396 41.162 33.0029 40.9195C34.6662 40.6771 36.187 39.8449 37.2878 38.5747C38.3887 37.3044 38.9964 35.6809 39 34C39 30.14 35.86 27 32 27C30.1 27 28.36 27.76 27.1 29H30V32H22V24H25V26.86C26.8 25.1 29.28 24 32 24C37.52 24 42 28.48 42 34C41.9928 36.4741 41.069 38.8578 39.4071 40.6907C37.7452 42.5235 35.463 43.6755 33.0014 43.9242C30.5398 44.1728 28.0734 43.5005 26.0785 42.037C24.0836 40.5735 22.7018 38.4227 22.2 36H25.28Z"
        fill="#C5CEE0"
      />
    </svg>
  )
}
const Eye = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
        stroke="#2E3A59"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke="#2E3A59"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
const Clear = (props) => {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0699 17.07C13.1461 20.8597 6.90908 20.8055 3.05174 16.9482C-0.805601 13.0908 -0.859799 6.85377 2.92992 2.92998C6.85371 -0.859738 13.0908 -0.80554 16.9481 3.0518C20.8054 6.90914 20.8596 13.1462 17.0699 17.07ZM14.2599 7.15998L11.4099 9.99998L14.2599 12.84C14.4492 13.0278 14.5557 13.2833 14.5557 13.55C14.5557 13.8166 14.4492 14.0722 14.2599 14.26C14.0712 14.4472 13.8157 14.5515 13.5499 14.55C13.2841 14.5515 13.0286 14.4472 12.8399 14.26L9.99992 11.41L7.15992 14.26C6.9712 14.4472 6.71573 14.5515 6.44992 14.55C6.18412 14.5515 5.92864 14.4472 5.73992 14.26C5.55061 14.0722 5.44412 13.8166 5.44412 13.55C5.44412 13.2833 5.55061 13.0278 5.73992 12.84L8.58992 9.99998L5.73992 7.15998C5.48626 6.90633 5.3872 6.53661 5.48004 6.19011C5.57289 5.8436 5.84354 5.57295 6.19004 5.48011C6.53655 5.38726 6.90626 5.48633 7.15992 5.73998L9.99992 8.58998L12.8399 5.73998C13.0936 5.48633 13.4633 5.38726 13.8098 5.48011C14.1563 5.57295 14.427 5.8436 14.5198 6.19011C14.6126 6.53661 14.5136 6.90633 14.2599 7.15998ZM4.34831 4.34418C7.47111 1.22022 12.5348 1.21835 15.6599 4.33998C17.1745 5.83392 18.0272 7.87257 18.0272 9.99998C18.0272 12.1274 17.1745 14.1661 15.6599 15.66C12.5348 18.7816 7.47111 18.7797 4.34831 15.6558C1.22552 12.5318 1.22552 7.46813 4.34831 4.34418Z"
        fill="#BDBDBD"
      />
    </svg>
  )
}
const BreadcrumbArrow = () => {
  return (
    <svg
      width="7"
      height="13"
      viewBox="0 0 7 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.939453 12.03L5.28612 7.6833C5.79945 7.16997 5.79945 6.32997 5.28612 5.81664L0.939453 1.46997"
        stroke="#8F9BB3"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
const Location = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0009 13.43C13.724 13.43 15.1209 12.0331 15.1209 10.31C15.1209 8.58687 13.724 7.19 12.0009 7.19C10.2777 7.19 8.88086 8.58687 8.88086 10.31C8.88086 12.0331 10.2777 13.43 12.0009 13.43Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M3.61971 8.49C5.58971 -0.169998 18.4197 -0.159997 20.3797 8.5C21.5297 13.58 18.3697 17.88 15.5997 20.54C13.5897 22.48 10.4097 22.48 8.38971 20.54C5.62971 17.88 2.46971 13.57 3.61971 8.49Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  )
}
const Clock = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7109 15.18L12.6109 13.33C12.0709 13.01 11.6309 12.24 11.6309 11.61V7.50999"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
const Call = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.45 22.75C16.32 22.75 15.13 22.48 13.9 21.96C12.7 21.45 11.49 20.75 10.31 19.9C9.14 19.04 8.01 18.08 6.94 17.03C5.88 15.96 4.92 14.83 4.07 13.67C3.21 12.47 2.52 11.27 2.03 10.11C1.51 8.87 1.25 7.67 1.25 6.54C1.25 5.76 1.39 5.02 1.66 4.33C1.94 3.62 2.39 2.96 3 2.39C3.77 1.63 4.65 1.25 5.59 1.25C5.98 1.25 6.38 1.34 6.72 1.5C7.11 1.68 7.44 1.95 7.68 2.31L10 5.58C10.21 5.87 10.37 6.15 10.48 6.43C10.61 6.73 10.68 7.03 10.68 7.32C10.68 7.7 10.57 8.07 10.36 8.42C10.21 8.69 9.98 8.98 9.69 9.27L9.01 9.98C9.02 10.01 9.03 10.03 9.04 10.05C9.16 10.26 9.4 10.62 9.86 11.16C10.35 11.72 10.81 12.23 11.27 12.7C11.86 13.28 12.35 13.74 12.81 14.12C13.38 14.6 13.75 14.84 13.97 14.95L13.95 15L14.68 14.28C14.99 13.97 15.29 13.74 15.58 13.59C16.13 13.25 16.83 13.19 17.53 13.48C17.79 13.59 18.07 13.74 18.37 13.95L21.69 16.31C22.06 16.56 22.33 16.88 22.49 17.26C22.64 17.64 22.71 17.99 22.71 18.34C22.71 18.82 22.6 19.3 22.39 19.75C22.18 20.2 21.92 20.59 21.59 20.95C21.02 21.58 20.4 22.03 19.68 22.32C18.99 22.6 18.24 22.75 17.45 22.75ZM5.59 2.75C5.04 2.75 4.53 2.99 4.04 3.47C3.58 3.9 3.26 4.37 3.06 4.88C2.85 5.4 2.75 5.95 2.75 6.54C2.75 7.47 2.97 8.48 3.41 9.52C3.86 10.58 4.49 11.68 5.29 12.78C6.09 13.88 7 14.95 8 15.96C9 16.95 10.08 17.87 11.19 18.68C12.27 19.47 13.38 20.11 14.48 20.57C16.19 21.3 17.79 21.47 19.11 20.92C19.62 20.71 20.07 20.39 20.48 19.93C20.71 19.68 20.89 19.41 21.04 19.09C21.16 18.84 21.22 18.58 21.22 18.32C21.22 18.16 21.19 18 21.11 17.82C21.08 17.76 21.02 17.65 20.83 17.52L17.51 15.16C17.31 15.02 17.13 14.92 16.96 14.85C16.74 14.76 16.65 14.67 16.31 14.88C16.11 14.98 15.93 15.13 15.73 15.33L14.97 16.08C14.58 16.46 13.98 16.55 13.52 16.38L13.25 16.26C12.84 16.04 12.36 15.7 11.83 15.25C11.35 14.84 10.83 14.36 10.2 13.74C9.71 13.24 9.22 12.71 8.71 12.12C8.24 11.57 7.9 11.1 7.69 10.71L7.57 10.41C7.51 10.18 7.49 10.05 7.49 9.91C7.49 9.55 7.62 9.23 7.87 8.98L8.62 8.2C8.82 8 8.97 7.81 9.07 7.64C9.15 7.51 9.18 7.4 9.18 7.3C9.18 7.22 9.15 7.1 9.1 6.98C9.03 6.82 8.92 6.64 8.78 6.45L6.46 3.17C6.36 3.03 6.24 2.93 6.09 2.86C5.93 2.79 5.76 2.75 5.59 2.75ZM13.95 15.01L13.79 15.69L14.06 14.99C14.01 14.98 13.97 14.99 13.95 15.01Z"
        fill="white"
      />
    </svg>
  )
}
const Sms = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 21.25H7C3.35 21.25 1.25 19.15 1.25 15.5V8.5C1.25 4.85 3.35 2.75 7 2.75H17C20.65 2.75 22.75 4.85 22.75 8.5V15.5C22.75 19.15 20.65 21.25 17 21.25ZM7 4.25C4.14 4.25 2.75 5.64 2.75 8.5V15.5C2.75 18.36 4.14 19.75 7 19.75H17C19.86 19.75 21.25 18.36 21.25 15.5V8.5C21.25 5.64 19.86 4.25 17 4.25H7Z"
        fill="white"
      />
      <path
        d="M11.9988 12.87C11.1588 12.87 10.3088 12.61 9.6588 12.08L6.5288 9.57997C6.2088 9.31997 6.14881 8.84997 6.4088 8.52997C6.66881 8.20997 7.13881 8.14997 7.45881 8.40997L10.5888 10.91C11.3488 11.52 12.6388 11.52 13.3988 10.91L16.5288 8.40997C16.8488 8.14997 17.3288 8.19997 17.5788 8.52997C17.8388 8.84997 17.7888 9.32997 17.4588 9.57997L14.3288 12.08C13.6888 12.61 12.8388 12.87 11.9988 12.87Z"
        fill="white"
      />
    </svg>
  )
}
const Calendar = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.625 2.3125H14.6875V0.8125C14.6875 0.709375 14.6031 0.625 14.5 0.625H13.1875C13.0844 0.625 13 0.709375 13 0.8125V2.3125H7V0.8125C7 0.709375 6.91563 0.625 6.8125 0.625H5.5C5.39687 0.625 5.3125 0.709375 5.3125 0.8125V2.3125H1.375C0.960156 2.3125 0.625 2.64766 0.625 3.0625V18.625C0.625 19.0398 0.960156 19.375 1.375 19.375H18.625C19.0398 19.375 19.375 19.0398 19.375 18.625V3.0625C19.375 2.64766 19.0398 2.3125 18.625 2.3125ZM17.6875 17.6875H2.3125V8.78125H17.6875V17.6875ZM2.3125 7.1875V4H5.3125V5.125C5.3125 5.22813 5.39687 5.3125 5.5 5.3125H6.8125C6.91563 5.3125 7 5.22813 7 5.125V4H13V5.125C13 5.22813 13.0844 5.3125 13.1875 5.3125H14.5C14.6031 5.3125 14.6875 5.22813 14.6875 5.125V4H17.6875V7.1875H2.3125Z"
        fill="#166FE5"
      />
    </svg>
  )
}
const Map = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 14C14.206 14 16 12.206 16 10C16 7.794 14.206 6 12 6C9.794 6 8 7.794 8 10C8 12.206 9.794 14 12 14ZM12 8C13.103 8 14 8.897 14 10C14 11.103 13.103 12 12 12C10.897 12 10 11.103 10 10C10 8.897 10.897 8 12 8Z"
        fill="#166FE5"
      />
      <path
        d="M11.4201 21.814C11.5893 21.9349 11.7921 21.9998 12.0001 21.9998C12.2081 21.9998 12.4108 21.9349 12.5801 21.814C12.8841 21.599 20.0291 16.44 20.0001 10C20.0001 5.589 16.4111 2 12.0001 2C7.58909 2 4.00009 5.589 4.00009 9.995C3.97109 16.44 11.1161 21.599 11.4201 21.814ZM12.0001 4C15.3091 4 18.0001 6.691 18.0001 10.005C18.0211 14.443 13.6121 18.428 12.0001 19.735C10.3891 18.427 5.97909 14.441 6.00009 10C6.00009 6.691 8.69109 4 12.0001 4Z"
        fill="#166FE5"
      />
    </svg>
  )
}
const Info = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.75 16.5V10.5H9.75V12H11.25V16.5H9V18H15V16.5H12.75ZM12 6C11.7775 6 11.56 6.06598 11.375 6.1896C11.19 6.31321 11.0458 6.48891 10.9606 6.69448C10.8755 6.90005 10.8532 7.12625 10.8966 7.34448C10.94 7.56271 11.0472 7.76316 11.2045 7.9205C11.3618 8.07783 11.5623 8.18498 11.7805 8.22838C11.9988 8.27179 12.225 8.24951 12.4305 8.16436C12.6361 8.07922 12.8118 7.93502 12.9354 7.75002C13.059 7.56501 13.125 7.3475 13.125 7.125C13.125 6.82663 13.0065 6.54048 12.7955 6.3295C12.5845 6.11853 12.2984 6 12 6Z"
        fill="#166FE5"
      />
      <path
        d="M12 22.5C9.9233 22.5 7.89323 21.8842 6.16652 20.7304C4.4398 19.5767 3.09399 17.9368 2.29927 16.0182C1.50455 14.0996 1.29661 11.9884 1.70176 9.95156C2.1069 7.91476 3.10693 6.04383 4.57538 4.57538C6.04383 3.10693 7.91476 2.1069 9.95156 1.70176C11.9884 1.29661 14.0996 1.50455 16.0182 2.29927C17.9368 3.09399 19.5767 4.4398 20.7304 6.16652C21.8842 7.89323 22.5 9.9233 22.5 12C22.5 14.7848 21.3938 17.4555 19.4246 19.4246C17.4555 21.3938 14.7848 22.5 12 22.5ZM12 3C10.22 3 8.47992 3.52785 6.99987 4.51678C5.51983 5.50571 4.36628 6.91132 3.68509 8.55585C3.0039 10.2004 2.82567 12.01 3.17294 13.7558C3.5202 15.5016 4.37737 17.1053 5.63604 18.364C6.89472 19.6226 8.49836 20.4798 10.2442 20.8271C11.99 21.1743 13.7996 20.9961 15.4442 20.3149C17.0887 19.6337 18.4943 18.4802 19.4832 17.0001C20.4722 15.5201 21 13.78 21 12C21 9.61306 20.0518 7.32387 18.364 5.63604C16.6761 3.94822 14.387 3 12 3Z"
        fill="#166FE5"
      />
    </svg>
  )
}
const Issue = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 18V2H2V17C2 17.2652 2.10536 17.5196 2.29289 17.7071C2.48043 17.8946 2.73478 18 3 18H14ZM17 20H3C2.20435 20 1.44129 19.6839 0.87868 19.1213C0.316071 18.5587 0 17.7956 0 17V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H15C15.2652 0 15.5196 0.105357 15.7071 0.292893C15.8946 0.48043 16 0.734784 16 1V8H20V17C20 17.7956 19.6839 18.5587 19.1213 19.1213C18.5587 19.6839 17.7956 20 17 20ZM16 10V17C16 17.2652 16.1054 17.5196 16.2929 17.7071C16.4804 17.8946 16.7348 18 17 18C17.2652 18 17.5196 17.8946 17.7071 17.7071C17.8946 17.5196 18 17.2652 18 17V10H16ZM4 4H10V10H4V4ZM6 6V8H8V6H6ZM4 11H12V13H4V11ZM4 14H12V16H4V14Z"
        fill="#166FE5"
      />
    </svg>
  )
}
const SlideArrow = () => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 6L3.135 6L6.768 1.64C7.122 1.216 7.064 0.584999 6.64 0.232C6.215 -0.122001 5.585 -0.064001 5.231 0.359999L0.231001 6.36C0.192001 6.407 0.173001 6.462 0.144001 6.514C0.120001 6.556 0.0910003 6.592 0.0730006 6.638C0.0280005 6.753 0.00100103 6.874 0.00100102 6.996C0.00100102 6.997 6.12047e-07 6.999 6.11959e-07 7C6.11872e-07 7.001 0.00100102 7.003 0.00100102 7.004C0.00100101 7.126 0.0280005 7.247 0.0730005 7.362C0.0910002 7.408 0.12 7.444 0.144001 7.486C0.173001 7.538 0.192001 7.593 0.231001 7.64L5.231 13.64C5.43 13.877 5.714 14 6 14C6.226 14 6.453 13.924 6.64 13.768C7.064 13.415 7.122 12.784 6.768 12.36L3.135 8L15 8C15.552 8 16 7.552 16 7C16 6.448 15.552 6 15 6Z"
        fill="#201B1C"
      />
    </svg>
  )
}
const Account = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 9.99C20 4.475 15.52 0 10 0C4.48 0 0 4.475 0 9.99C0 13.0275 1.38 15.765 3.54 17.6025C3.56 17.6225 3.58 17.6225 3.58 17.6425C3.76 17.7825 3.94 17.9225 4.14 18.0625C4.24 18.1225 4.32 18.2013 4.42 18.2812C6.07258 19.4017 8.02339 20.0004 10.02 20C12.0166 20.0004 13.9674 19.4017 15.62 18.2812C15.72 18.2213 15.8 18.1425 15.9 18.0812C16.08 17.9425 16.28 17.8025 16.46 17.6625C16.48 17.6425 16.5 17.6425 16.5 17.6225C18.62 15.7637 20 13.0275 20 9.99ZM10 18.7412C8.12 18.7412 6.4 18.1413 4.98 17.1425C5 16.9825 5.04 16.8237 5.08 16.6637C5.19917 16.2301 5.37396 15.8138 5.6 15.425C5.82 15.045 6.08 14.705 6.4 14.405C6.7 14.105 7.06 13.8263 7.42 13.6063C7.8 13.3863 8.2 13.2262 8.64 13.1062C9.08342 12.9867 9.54075 12.9266 10 12.9275C11.3633 12.9178 12.6765 13.4408 13.66 14.385C14.12 14.845 14.48 15.385 14.74 16.0037C14.88 16.3638 14.98 16.7437 15.04 17.1425C13.564 18.1802 11.8043 18.7384 10 18.7412ZM6.94 9.49125C6.76378 9.08778 6.67516 8.6515 6.68 8.21125C6.68 7.7725 6.76 7.3325 6.94 6.9325C7.12 6.5325 7.36 6.17375 7.66 5.87375C7.96 5.57375 8.32 5.335 8.72 5.155C9.12 4.975 9.56 4.895 10 4.895C10.46 4.895 10.88 4.975 11.28 5.155C11.68 5.335 12.04 5.575 12.34 5.87375C12.64 6.17375 12.88 6.53375 13.06 6.9325C13.24 7.3325 13.32 7.7725 13.32 8.21125C13.32 8.67125 13.24 9.09125 13.06 9.49C12.8863 9.88408 12.6423 10.2433 12.34 10.55C12.0332 10.8519 11.674 11.0954 11.28 11.2688C10.4535 11.6084 9.52647 11.6084 8.7 11.2688C8.30602 11.0954 7.94684 10.8519 7.64 10.55C7.33727 10.2477 7.09912 9.8871 6.94 9.49V9.49125ZM16.22 16.1238C16.22 16.0837 16.2 16.0638 16.2 16.0238C16.0033 15.398 15.7134 14.8055 15.34 14.2663C14.9663 13.723 14.507 13.2438 13.98 12.8475C13.5775 12.5447 13.1413 12.2897 12.68 12.0875C12.8899 11.9491 13.0843 11.7886 13.26 11.6087C13.5582 11.3144 13.82 10.9854 14.04 10.6287C14.4829 9.90101 14.7117 9.06311 14.7 8.21125C14.7062 7.58064 14.5837 6.9554 14.34 6.37375C14.0994 5.8133 13.7531 5.30445 13.32 4.875C12.8876 4.45004 12.3786 4.11074 11.82 3.875C11.2374 3.63174 10.6113 3.50968 9.98 3.51625C9.34859 3.51007 8.72253 3.63256 8.14 3.87625C7.57657 4.11148 7.06639 4.45798 6.64 4.895C6.21505 5.32698 5.87574 5.83552 5.64 6.39375C5.39631 6.9754 5.27381 7.60064 5.28 8.23125C5.28 8.67125 5.34 9.09125 5.46 9.49C5.58 9.91 5.74 10.29 5.96 10.6488C6.16 11.0087 6.44 11.3288 6.74 11.6288C6.92 11.8088 7.12 11.9675 7.34 12.1075C6.87729 12.3151 6.4409 12.5769 6.04 12.8875C5.52 13.2875 5.06 13.7662 4.68 14.2863C4.30282 14.8233 4.0126 15.4164 3.82 16.0438C3.8 16.0837 3.8 16.1238 3.8 16.1437C2.22 14.545 1.24 12.3875 1.24 9.99C1.24 5.175 5.18 1.23875 10 1.23875C14.82 1.23875 18.76 5.175 18.76 9.99C18.7574 12.2899 17.8441 14.4953 16.22 16.1238Z"
        fill="#166FE5"
      />
    </svg>
  )
}
const Education = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.25 16.4364L12 19.3895L6.75 16.4364V13.3163L5.25 12.483V17.3136L12 21.1105L18.75 17.3136V12.483L17.25 13.3163V16.4364Z"
        fill="#166FE5"
      />
      <path
        d="M12 2.15517L1.5 7.59962V8.89965L12 14.7328L21 9.73299V13.875H22.5V7.59962L12 2.15517ZM19.5 8.85038L18 9.68368L12 13.0172L6 9.68368L4.5 8.85038L3.46036 8.27279L12 3.84483L20.5396 8.27279L19.5 8.85038Z"
        fill="#166FE5"
      />
    </svg>
  )
}
const Plus = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 7H9V1C9 0.447 8.552 0 8 0C7.448 0 7 0.447 7 1V7H1C0.448 7 0 7.447 0 8C0 8.553 0.448 9 1 9H7V15C7 15.553 7.448 16 8 16C8.552 16 9 15.553 9 15V9H15C15.552 9 16 8.553 16 8C16 7.447 15.552 7 15 7Z"
        fill="#0095FF"
      />
    </svg>
  )
}
const Language = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0026 2H9.33594V5.33333H10.6693V3.33333H20.0026C20.4026 3.33333 20.6693 3.6 20.6693 4V11.3333C20.6693 11.7333 20.4026 12 20.0026 12H11.3359V16.6667H7.8026L5.33594 18.6V16.6667H3.33594C2.93594 16.6667 2.66927 16.4 2.66927 16V8.66667C2.66927 8.26667 2.93594 8 3.33594 8H12.0026V6.66667H3.33594C2.2026 6.66667 1.33594 7.53333 1.33594 8.66667V16C1.33594 17.1333 2.2026 18 3.33594 18H4.0026V21.4L8.2026 18H12.6693V13.3333H20.0026C21.1359 13.3333 22.0026 12.4667 22.0026 11.3333V4C22.0026 2.86667 21.1359 2 20.0026 2Z"
        fill="#166FE5"
      />
      <path
        d="M4.13281 15.2667H5.73281L6.13281 14.2H8.19948L8.59948 15.2667H10.1995L7.93281 9.33337H6.33281L4.13281 15.2667ZM7.13281 11L7.79948 13.0667H6.46615L7.13281 11Z"
        fill="#166FE5"
      />
      <path
        d="M13.3359 11.3333C14.0693 11.3333 15.0693 11.1333 16.0026 10.6667C16.9359 11.1333 18.0026 11.3333 18.6693 11.3333V10C18.6693 10 18.0026 10 17.2693 9.73333C18.0693 8.93333 18.6693 7.73333 18.6693 6V5.33333H16.6693V4H15.3359V5.33333H13.3359V6.66667H17.2693C17.1359 7.86667 16.6026 8.6 16.0026 9.06667C15.6026 8.73333 15.2026 8.26667 14.9359 7.66667H13.5359C13.8026 8.53333 14.2026 9.2 14.7359 9.73333C14.0693 10 13.4693 10 13.3359 10V11.3333Z"
        fill="#166FE5"
      />
    </svg>
  )
}
const Work = () => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 3C14 2.20435 13.6839 1.44129 13.1213 0.87868C12.5587 0.316071 11.7956 0 11 0H7C6.20435 0 5.44129 0.316071 4.87868 0.87868C4.31607 1.44129 4 2.20435 4 3H3C2.20435 3 1.44129 3.31607 0.87868 3.87868C0.316071 4.44129 0 5.20435 0 6V14C0 14.7956 0.316071 15.5587 0.87868 16.1213C1.44129 16.6839 2.20435 17 3 17H15C15.7956 17 16.5587 16.6839 17.1213 16.1213C17.6839 15.5587 18 14.7956 18 14V6C18 5.20435 17.6839 4.44129 17.1213 3.87868C16.5587 3.31607 15.7956 3 15 3H14ZM11 2H7C6.73478 2 6.48043 2.10536 6.29289 2.29289C6.10536 2.48043 6 2.73478 6 3H12C12 2.73478 11.8946 2.48043 11.7071 2.29289C11.5196 2.10536 11.2652 2 11 2ZM3 5H15C15.2652 5 15.5196 5.10536 15.7071 5.29289C15.8946 5.48043 16 5.73478 16 6V14C16 14.2652 15.8946 14.5196 15.7071 14.7071C15.5196 14.8946 15.2652 15 15 15H3C2.73478 15 2.48043 14.8946 2.29289 14.7071C2.10536 14.5196 2 14.2652 2 14V6C2 5.73478 2.10536 5.48043 2.29289 5.29289C2.48043 5.10536 2.73478 5 3 5Z"
        fill="#166FE5"
      />
    </svg>
  )
}
const WorkPlace = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9983 15H18.9983V17H16.9983V15ZM16.9983 11H18.9983V13H16.9983V11ZM16.9983 7H18.9983V9H16.9983V7ZM13.7383 7L14.9983 7.84V7H13.7383Z"
        fill="#166FE5"
      />
      <path d="M10 3V4.51L12 5.84V5H21V19H17V21H23V3H10Z" fill="#166FE5" />
      <path
        d="M8.17 5.7L15 10.25V21H1V10.48L8.17 5.7ZM10 19H13V11.16L8.17 8.09L3 11.38V19H6V13H10V19Z"
        fill="#166FE5"
      />
    </svg>
  )
}
const SmsOrange = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 21.25H7C3.35 21.25 1.25 19.15 1.25 15.5V8.5C1.25 4.85 3.35 2.75 7 2.75H17C20.65 2.75 22.75 4.85 22.75 8.5V15.5C22.75 19.15 20.65 21.25 17 21.25ZM7 4.25C4.14 4.25 2.75 5.64 2.75 8.5V15.5C2.75 18.36 4.14 19.75 7 19.75H17C19.86 19.75 21.25 18.36 21.25 15.5V8.5C21.25 5.64 19.86 4.25 17 4.25H7Z"
        fill="#DB8B00"
      />
      <path
        d="M11.9988 12.87C11.1588 12.87 10.3088 12.61 9.6588 12.08L6.5288 9.57997C6.2088 9.31997 6.14881 8.84997 6.4088 8.52997C6.66881 8.20997 7.13881 8.14997 7.45881 8.40997L10.5888 10.91C11.3488 11.52 12.6388 11.52 13.3988 10.91L16.5288 8.40997C16.8488 8.14997 17.3288 8.19997 17.5788 8.52997C17.8388 8.84997 17.7888 9.32997 17.4588 9.57997L14.3288 12.08C13.6888 12.61 12.8388 12.87 11.9988 12.87Z"
        fill="#DB8B00"
      />
    </svg>
  )
}
const Timer = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 18.75C8.26942 18.75 6.57769 18.2368 5.13876 17.2754C3.69983 16.3139 2.57832 14.9473 1.91606 13.3485C1.25379 11.7496 1.08051 9.9903 1.41813 8.29296C1.75575 6.59563 2.58911 5.03653 3.81282 3.81282C5.03653 2.58911 6.59563 1.75575 8.29296 1.41813C9.9903 1.08051 11.7496 1.25379 13.3485 1.91606C14.9473 2.57832 16.3139 3.69983 17.2754 5.13876C18.2368 6.57769 18.75 8.26942 18.75 10C18.75 12.3206 17.8281 14.5462 16.1872 16.1872C14.5462 17.8281 12.3206 18.75 10 18.75ZM10 2.5C8.51664 2.5 7.0666 2.93987 5.83323 3.76398C4.59986 4.58809 3.63856 5.75943 3.07091 7.12988C2.50325 8.50032 2.35473 10.0083 2.64411 11.4632C2.9335 12.918 3.64781 14.2544 4.6967 15.3033C5.7456 16.3522 7.08197 17.0665 8.53683 17.3559C9.99168 17.6453 11.4997 17.4968 12.8701 16.9291C14.2406 16.3614 15.4119 15.4001 16.236 14.1668C17.0601 12.9334 17.5 11.4834 17.5 10C17.5 8.01088 16.7098 6.10323 15.3033 4.6967C13.8968 3.29018 11.9891 2.5 10 2.5Z"
        fill="#5B748D"
      />
      <path
        d="M12.8688 13.75L9.375 10.2562V4.375H10.625V9.7375L13.75 12.8687L12.8688 13.75Z"
        fill="#5B748D"
      />
    </svg>
  )
}
const Help = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM12 20.7188C7.18594 20.7188 3.28125 16.8141 3.28125 12C3.28125 7.18594 7.18594 3.28125 12 3.28125C16.8141 3.28125 20.7188 7.18594 20.7188 12C20.7188 16.8141 16.8141 20.7188 12 20.7188Z"
        fill="#166FE5"
      />
      <path
        d="M14.6156 7.42266C13.9125 6.80625 12.9844 6.46875 12 6.46875C11.0156 6.46875 10.0875 6.80859 9.38437 7.42266C8.65312 8.0625 8.25 8.92266 8.25 9.84375V10.0219C8.25 10.125 8.33438 10.2094 8.4375 10.2094H9.5625C9.66563 10.2094 9.75 10.125 9.75 10.0219V9.84375C9.75 8.81016 10.7602 7.96875 12 7.96875C13.2398 7.96875 14.25 8.81016 14.25 9.84375C14.25 10.5727 13.7344 11.2406 12.9352 11.5477C12.4383 11.7375 12.0164 12.0703 11.7141 12.5062C11.407 12.9516 11.2477 13.4859 11.2477 14.0273V14.5312C11.2477 14.6344 11.332 14.7188 11.4352 14.7188H12.5602C12.6633 14.7188 12.7477 14.6344 12.7477 14.5312V13.9992C12.7489 13.7717 12.8186 13.5498 12.9478 13.3625C13.077 13.1752 13.2596 13.0312 13.4719 12.9492C14.8547 12.4172 15.7477 11.1984 15.7477 9.84375C15.75 8.92266 15.3469 8.0625 14.6156 7.42266ZM11.0625 17.1562C11.0625 17.4049 11.1613 17.6433 11.3371 17.8192C11.5129 17.995 11.7514 18.0938 12 18.0938C12.2486 18.0938 12.4871 17.995 12.6629 17.8192C12.8387 17.6433 12.9375 17.4049 12.9375 17.1562C12.9375 16.9076 12.8387 16.6692 12.6629 16.4933C12.4871 16.3175 12.2486 16.2188 12 16.2188C11.7514 16.2188 11.5129 16.3175 11.3371 16.4933C11.1613 16.6692 11.0625 16.9076 11.0625 17.1562Z"
        fill="#166FE5"
      />
    </svg>
  )
}
const CallCentre = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 13.42V16.956C18.0001 17.2092 17.9042 17.453 17.7316 17.6382C17.559 17.8234 17.3226 17.9363 17.07 17.954C16.633 17.984 16.276 18 16 18C7.163 18 0 10.837 0 2C0 1.724 0.015 1.367 0.046 0.93C0.0637224 0.677444 0.176581 0.441011 0.361804 0.268409C0.547026 0.0958068 0.790823 -0.000114433 1.044 2.56579e-07H4.58C4.70404 -0.000125334 4.8237 0.045859 4.91573 0.12902C5.00776 0.212182 5.0656 0.326583 5.078 0.45C5.101 0.68 5.122 0.863 5.142 1.002C5.34073 2.38892 5.748 3.73783 6.35 5.003C6.445 5.203 6.383 5.442 6.203 5.57L4.045 7.112C5.36445 10.1865 7.81455 12.6365 10.889 13.956L12.429 11.802C12.4919 11.714 12.5838 11.6509 12.6885 11.6237C12.7932 11.5964 12.9042 11.6068 13.002 11.653C14.267 12.2539 15.6156 12.6601 17.002 12.858C17.141 12.878 17.324 12.9 17.552 12.922C17.6752 12.9346 17.7894 12.9926 17.8724 13.0846C17.9553 13.1766 18.0012 13.2961 18.001 13.42H18Z"
        fill="#006FD6"
      />
    </svg>
  )
}
const InstaIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.9906 0H0.009375C0.00419733 0 0 0.00419733 0 0.009375V31.9906C0 31.9958 0.00419733 32 0.009375 32H31.9906C31.9958 32 32 31.9958 32 31.9906V0.009375C32 0.00419733 31.9958 0 31.9906 0Z"
        fill="url(#paint0_linear_2122_12569)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4375 7.3125C9.15932 7.3125 7.3125 9.15932 7.3125 11.4375V20.5625C7.3125 22.8407 9.15932 24.6875 11.4375 24.6875H20.5625C22.8407 24.6875 24.6875 22.8407 24.6875 20.5625V11.4375C24.6875 9.15932 22.8407 7.3125 20.5625 7.3125H11.4375ZM5.4375 11.4375C5.4375 8.12379 8.12379 5.4375 11.4375 5.4375H20.5625C23.8762 5.4375 26.5625 8.12379 26.5625 11.4375V20.5625C26.5625 23.8762 23.8762 26.5625 20.5625 26.5625H11.4375C8.12379 26.5625 5.4375 23.8762 5.4375 20.5625V11.4375Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 12.4376C14.0325 12.4376 12.4375 14.0326 12.4375 16.0001C12.4375 17.9676 14.0325 19.5626 16 19.5626C17.9675 19.5626 19.5625 17.9676 19.5625 16.0001C19.5625 14.0326 17.9675 12.4376 16 12.4376ZM10.5625 16.0001C10.5625 12.997 12.9969 10.5626 16 10.5626C19.003 10.5626 21.4375 12.997 21.4375 16.0001C21.4375 19.0031 19.003 21.4376 16 21.4376C12.9969 21.4376 10.5625 19.0031 10.5625 16.0001Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6875 10.8751C21.9982 10.8751 22.25 10.6232 22.25 10.3126C22.25 10.0019 21.9982 9.75008 21.6875 9.75008C21.3768 9.75008 21.125 10.0019 21.125 10.3126C21.125 10.6232 21.3768 10.8751 21.6875 10.8751ZM20.375 10.3126C20.375 9.58771 20.9626 9.00008 21.6875 9.00008C22.4124 9.00008 23 9.58771 23 10.3126C23 11.0375 22.4124 11.6251 21.6875 11.6251C20.9626 11.6251 20.375 11.0375 20.375 10.3126Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2122_12569"
          x1="30.6034"
          y1="1.39107"
          x2="1.39106"
          y2="31.299"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#873AC8" />
          <stop offset="0.13234" stopColor="#A936AF" />
          <stop offset="0.279291" stopColor="#BC329C" />
          <stop offset="0.495796" stopColor="#DA2F72" />
          <stop offset="0.747405" stopColor="#F6752F" />
          <stop offset="0.890248" stopColor="#FCBF59" />
          <stop offset="1" stopColor="#FCC564" />
        </linearGradient>
      </defs>
    </svg>
  )
}
const SlideArrowIcon = () => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 6L3.135 6L6.768 1.64C7.122 1.216 7.064 0.584999 6.64 0.232C6.215 -0.122001 5.585 -0.064001 5.231 0.359999L0.231001 6.36C0.192001 6.407 0.173001 6.462 0.144001 6.514C0.120001 6.556 0.0910003 6.592 0.0730006 6.638C0.0280005 6.753 0.00100103 6.874 0.00100102 6.996C0.00100102 6.997 6.12047e-07 6.999 6.11959e-07 7C6.11872e-07 7.001 0.00100102 7.003 0.00100102 7.004C0.00100101 7.126 0.0280005 7.247 0.0730005 7.362C0.0910002 7.408 0.12 7.444 0.144001 7.486C0.173001 7.538 0.192001 7.593 0.231001 7.64L5.231 13.64C5.43 13.877 5.714 14 6 14C6.226 14 6.453 13.924 6.64 13.768C7.064 13.415 7.122 12.784 6.768 12.36L3.135 8L15 8C15.552 8 16 7.552 16 7C16 6.448 15.552 6 15 6Z"
        fill="#201B1C"
      />
    </svg>
  )
}
const CalendarIcon = (props) => {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.375 14.25C33.375 14.4562 33.2062 14.625 33 14.625H30.375C30.1688 14.625 30 14.4562 30 14.25V12H18V14.25C18 14.4562 17.8313 14.625 17.625 14.625H15C14.7937 14.625 14.625 14.4562 14.625 14.25V12H8.625V18.375H39.375V12H33.375V14.25Z"
        fill="#C5CEE0"
      />
      <path
        d="M41.25 8.625H33.375V5.625C33.375 5.41875 33.2062 5.25 33 5.25H30.375C30.1688 5.25 30 5.41875 30 5.625V8.625H18V5.625C18 5.41875 17.8312 5.25 17.625 5.25H15C14.7938 5.25 14.625 5.41875 14.625 5.625V8.625H6.75C5.92031 8.625 5.25 9.29531 5.25 10.125V41.25C5.25 42.0797 5.92031 42.75 6.75 42.75H41.25C42.0797 42.75 42.75 42.0797 42.75 41.25V10.125C42.75 9.29531 42.0797 8.625 41.25 8.625ZM39.375 39.375H8.625V21.5625H39.375V39.375ZM39.375 18.375H8.625V12H14.625V14.25C14.625 14.4562 14.7938 14.625 15 14.625H17.625C17.8312 14.625 18 14.4562 18 14.25V12H30V14.25C30 14.4562 30.1688 14.625 30.375 14.625H33C33.2062 14.625 33.375 14.4562 33.375 14.25V12H39.375V18.375Z"
        fill="#C5CEE0"
      />
    </svg>
  )
}
const LibraryIcon = (props) => {
  return (
    <svg
      {...props}
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.200012 4.09475C0.200012 1.94195 1.94461 0.199951 4.10001 0.199951H6.70001C8.85021 0.199951 10.5974 1.94195 10.5974 4.09475V37.848C10.5974 39.9982 8.85021 41.7402 6.69741 41.7402H4.09741C1.94461 41.7402 0.200012 39.9982 0.200012 37.848V4.09475ZM4.10001 2.79475C3.75523 2.79475 3.42457 2.93172 3.18077 3.17551C2.93698 3.41931 2.80001 3.74997 2.80001 4.09475V37.848C2.8007 38.1923 2.93797 38.5223 3.18169 38.7655C3.42541 39.0087 3.75568 39.1454 4.10001 39.1454H6.70001C7.04434 39.1447 7.37434 39.0074 7.61757 38.7637C7.86081 38.52 7.99741 38.1897 7.99741 37.8454V4.09735C7.99741 3.75257 7.86045 3.42191 7.61665 3.17811C7.37285 2.93431 7.04219 2.79735 6.69741 2.79735H4.09741L4.10001 2.79475ZM13.1948 4.09475C13.1948 1.94195 14.942 0.199951 17.0948 0.199951H19.6948C21.8476 0.199951 23.5922 1.94195 23.5922 4.09475V37.848C23.5922 39.9982 21.8476 41.7402 19.6922 41.7402H17.0922C14.942 41.7402 13.1948 39.9982 13.1948 37.848V4.09475ZM17.0948 2.79475C16.75 2.79475 16.4194 2.93172 16.1756 3.17551C15.9318 3.41931 15.7948 3.74997 15.7948 4.09475V37.848C15.7955 38.1923 15.9328 38.5223 16.1765 38.7655C16.4202 39.0087 16.7505 39.1454 17.0948 39.1454H19.6948C20.0396 39.1454 20.3703 39.0084 20.614 38.7646C20.8578 38.5208 20.9948 38.1901 20.9948 37.8454V4.09735C20.9948 3.75257 20.8578 3.42191 20.614 3.17811C20.3703 2.93431 20.0396 2.79735 19.6948 2.79735H17.0948V2.79475ZM35.8668 11.0082C35.748 10.4935 35.5259 10.0083 35.214 9.582C34.902 9.15573 34.5067 8.79727 34.0521 8.52837C33.5974 8.25947 33.0929 8.08573 32.5691 8.01769C32.0453 7.94965 31.5131 7.98873 31.0048 8.13255L29.0678 8.67855C28.122 8.94609 27.3124 9.56132 26.8012 10.4008C26.2901 11.2404 26.1153 12.2421 26.3118 13.2052L31.5196 38.6852C31.626 39.2015 31.836 39.691 32.1369 40.1239C32.4378 40.5569 32.8234 40.9243 33.2703 41.204C33.7172 41.4838 34.2162 41.67 34.7371 41.7514C35.258 41.8328 35.7901 41.8078 36.301 41.6777L38.862 41.0278C40.916 40.5078 42.1744 38.4434 41.7012 36.3816L35.8668 11.0056V11.0082ZM31.712 10.6312C31.8814 10.5829 32.0589 10.5696 32.2336 10.5921C32.4083 10.6145 32.5766 10.6722 32.7284 10.7617C32.8801 10.8512 33.012 10.9706 33.1162 11.1126C33.2204 11.2546 33.2946 11.4164 33.3344 11.588L39.1662 36.964C39.2411 37.2943 39.1841 37.6408 39.0073 37.9297C38.8306 38.2187 38.548 38.4272 38.2198 38.511L35.6588 39.161C35.4886 39.2043 35.3114 39.2127 35.1378 39.1857C34.9643 39.1587 34.798 39.0967 34.6491 39.0037C34.5001 38.9106 34.3716 38.7883 34.2712 38.6442C34.1708 38.5001 34.1007 38.3371 34.065 38.1651L28.8572 12.6852C28.7923 12.3644 28.8508 12.031 29.0209 11.7515C29.191 11.4719 29.4603 11.2669 29.775 11.1772L31.712 10.6312Z"
        fill="#C5CEE0"
      />
    </svg>
  )
}
const Cancel = (props) => {
  return (
    <svg
      {...props}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 0.4375C5.176 0.4375 0.4375 5.176 0.4375 11C0.4375 16.824 5.176 21.5625 11 21.5625C16.824 21.5625 21.5625 16.824 21.5625 11C21.5625 5.176 16.824 0.4375 11 0.4375ZM11 2.0625C15.9457 2.0625 19.9375 6.05431 19.9375 11C19.9375 15.9457 15.9457 19.9375 11 19.9375C6.05431 19.9375 2.0625 15.9457 2.0625 11C2.0625 6.05431 6.05431 2.0625 11 2.0625ZM7.92875 6.75875L6.75875 7.92875L9.83325 11L6.76037 14.0713L7.93038 15.2412L11 12.1676L14.0713 15.2388L15.2412 14.0713L12.1676 11L15.2388 7.92875L14.0713 6.75875L11 9.83325L7.92875 6.76037V6.75875Z"
        fill="black"
      />
    </svg>
  )
}
const Attention = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.41855 5.83334H7.58522V8.75001H6.41855V5.83334ZM6.41797 9.33334H7.58464V10.5H6.41797V9.33334Z"
        fill="#F50000"
      />
      <path
        d="M8.0309 2.45001C7.8279 2.06792 7.4324 1.83051 6.99956 1.83051C6.56673 1.83051 6.17123 2.06792 5.96823 2.45059L1.68773 10.5373C1.59274 10.7149 1.54569 10.9142 1.55122 11.1155C1.55674 11.3168 1.61465 11.5132 1.71923 11.6853C1.8223 11.8582 1.96869 12.0012 2.14393 12.1003C2.31916 12.1993 2.5172 12.2509 2.71848 12.25H11.2806C11.6936 12.25 12.0676 12.0388 12.2805 11.6853C12.3849 11.5132 12.4427 11.3168 12.4482 11.1155C12.4538 10.9142 12.4068 10.715 12.312 10.5373L8.0309 2.45001ZM2.71848 11.0833L6.99956 2.99659L11.2836 11.0833H2.71848Z"
        fill="#F50000"
      />
    </svg>
  )
}
const Book = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 18V2H2V17C2 17.2652 2.10536 17.5196 2.29289 17.7071C2.48043 17.8946 2.73478 18 3 18H14ZM17 20H3C2.20435 20 1.44129 19.6839 0.87868 19.1213C0.316071 18.5587 0 17.7956 0 17V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H15C15.2652 0 15.5196 0.105357 15.7071 0.292893C15.8946 0.48043 16 0.734784 16 1V8H20V17C20 17.7956 19.6839 18.5587 19.1213 19.1213C18.5587 19.6839 17.7956 20 17 20ZM16 10V17C16 17.2652 16.1054 17.5196 16.2929 17.7071C16.4804 17.8946 16.7348 18 17 18C17.2652 18 17.5196 17.8946 17.7071 17.7071C17.8946 17.5196 18 17.2652 18 17V10H16ZM4 4H10V10H4V4ZM6 6V8H8V6H6ZM4 11H12V13H4V11ZM4 14H12V16H4V14Z"
        fill="#166FE5"
      />
    </svg>
  )
}
const FullStar = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.875 13.175H20.9937L17 0.6875L13.0062 13.175H0.125L10.5312 20.8813L6.59375 33.3125L17 25.6062L27.4062 33.3125L23.4125 20.825L33.875 13.175Z"
        fill="#FFCE31"
      />
    </svg>
  )
}
const EmptyStar = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.875 13.175H20.9937L17 0.6875L13.0062 13.175H0.125L10.5312 20.8813L6.59375 33.3125L17 25.6062L27.4062 33.3125L23.4125 20.825L33.875 13.175Z"
        fill="#BDBDBD"
      />
    </svg>
  )
}
const Calculator = (props) => {
  return (
    <svg
      {...props}
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 0H17C17.2652 0 17.5196 0.105357 17.7071 0.292893C17.8946 0.48043 18 0.734784 18 1V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H1C0.734784 20 0.48043 19.8946 0.292893 19.7071C0.105357 19.5196 0 19.2652 0 19V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0ZM2 2V18H16V2H2ZM4 4H14V8H4V4ZM4 10H6V12H4V10ZM4 14H6V16H4V14ZM8 10H10V12H8V10ZM8 14H10V16H8V14ZM12 10H14V16H12V10Z"
        fill="#166FE5"
      />
    </svg>
  )
}
const Calculator2 = (props) => {
  return (
    <svg
      {...props}
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 0H17C17.2652 0 17.5196 0.105357 17.7071 0.292893C17.8946 0.48043 18 0.734784 18 1V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H1C0.734784 20 0.48043 19.8946 0.292893 19.7071C0.105357 19.5196 0 19.2652 0 19V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0ZM2 2V18H16V2H2ZM4 4H14V8H4V4ZM4 10H6V12H4V10ZM4 14H6V16H4V14ZM8 10H10V12H8V10ZM8 14H10V16H8V14ZM12 10H14V16H12V10Z"
        fill="#C5CEE0"
      />
    </svg>
  )
}
const Document = () => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 4.25V0H0.75C0.334375 0 0 0.334375 0 0.75V15.25C0 15.6656 0.334375 16 0.75 16H11.25C11.6656 16 12 15.6656 12 15.25V5H7.75C7.3375 5 7 4.6625 7 4.25ZM8.87813 7.57812L7 10.5L8.87813 13.4219C9.0375 13.6719 8.85938 14 8.5625 14H7.47188C7.33438 14 7.20625 13.925 7.14062 13.8031C6.52812 12.6719 6 11.6562 6 11.6562C5.8 12.1187 5.6875 12.2812 4.85625 13.8062C4.79062 13.9281 4.66562 14.0031 4.52812 14.0031H3.4375C3.14062 14.0031 2.9625 13.675 3.12188 13.425L5.00625 10.5031L3.12188 7.58125C2.95938 7.33125 3.14062 7.00313 3.4375 7.00313H4.525C4.6625 7.00313 4.79062 7.07812 4.85625 7.2C5.67188 8.725 5.48125 8.25 6 9.34062C6 9.34062 6.19063 8.975 7.14375 7.2C7.20938 7.07812 7.3375 7.00313 7.475 7.00313H8.5625C8.85938 7 9.0375 7.32812 8.87813 7.57812ZM12 3.80938V4H8V0H8.19063C8.39062 0 8.58125 0.078125 8.72188 0.21875L11.7812 3.28125C11.9219 3.42188 12 3.6125 12 3.80938Z"
        fill="#BDBDBD"
      />
    </svg>
  )
}
const CalendarDark = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25 8.25H6.75V9.75H5.25V8.25ZM5.25 11.25H6.75V12.75H5.25V11.25ZM8.25 8.25H9.75V9.75H8.25V8.25ZM8.25 11.25H9.75V12.75H8.25V11.25ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V12.75H11.25V11.25Z"
        fill="#7C7C7C"
      />
      <path
        d="M3.75 16.5H14.25C15.0773 16.5 15.75 15.8273 15.75 15V4.5C15.75 3.67275 15.0773 3 14.25 3H12.75V1.5H11.25V3H6.75V1.5H5.25V3H3.75C2.92275 3 2.25 3.67275 2.25 4.5V15C2.25 15.8273 2.92275 16.5 3.75 16.5ZM14.25 6L14.2507 15H3.75V6H14.25Z"
        fill="#7C7C7C"
      />
    </svg>
  )
}
const Increase = () => {
  return (
    <svg
      width="14"
      height="7"
      viewBox="0 0 14 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6342 6.0647L7.96557 1.38367C7.41421 0.830851 6.51199 0.830851 5.96063 1.38367L1.29199 6.0647"
        stroke="#00D68F"
        stroke-width="1.5"
        strokeMiterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
const Dot = () => {
  return (
    <svg
      width="9"
      height="10"
      viewBox="0 0 9 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4.5" cy="5" r="4.5" fill="#8F9BB3" />
    </svg>
  )
}
const Decrase = () => {
  return (
    <svg
      width="14"
      height="7"
      viewBox="0 0 14 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.36579 0.935302L6.03443 5.61633C6.58579 6.16915 7.48801 6.16915 8.03937 5.61633L12.708 0.935303"
        stroke="#FF3D71"
        stroke-width="1.5"
        strokeMiterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
const Teqvim = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 2H19C19.2652 2 19.5196 2.10536 19.7071 2.29289C19.8946 2.48043 20 2.73478 20 3V19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H1C0.734784 20 0.48043 19.8946 0.292893 19.7071C0.105357 19.5196 0 19.2652 0 19V3C0 2.73478 0.105357 2.48043 0.292893 2.29289C0.48043 2.10536 0.734784 2 1 2H5V0H7V2H13V0H15V2ZM18 10H2V18H18V10ZM13 4H7V6H5V4H2V8H18V4H15V6H13V4ZM4 12H6V14H4V12ZM9 12H11V14H9V12ZM14 12H16V14H14V12Z"
        fill="#166FE5"
      />
    </svg>
  )
}
const Journal = (props) => {
  return (
    <svg
      {...props}
      width="35"
      height="36"
      viewBox="0 0 35 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.70155 28.0433V21.3933H10.9682V28.0433H7.70155Z"
        fill="#C5CEE0"
      />
      <path
        d="M7.7013 7.09336C7.14902 7.09336 6.7013 7.54107 6.7013 8.09336C6.7013 8.64564 7.14902 9.09336 7.7013 9.09336V7.09336ZM27.3013 9.09336C27.8536 9.09336 28.3013 8.64564 28.3013 8.09336C28.3013 7.54107 27.8536 7.09336 27.3013 7.09336V9.09336ZM7.7013 13.7434C7.14902 13.7434 6.7013 14.1911 6.7013 14.7434C6.7013 15.2956 7.14902 15.7434 7.7013 15.7434V13.7434ZM27.3013 15.7434C27.8536 15.7434 28.3013 15.2956 28.3013 14.7434C28.3013 14.1911 27.8536 13.7434 27.3013 13.7434V15.7434ZM17.5013 20.3934C16.949 20.3934 16.5013 20.8411 16.5013 21.3934C16.5013 21.9456 16.949 22.3934 17.5013 22.3934V20.3934ZM27.3013 22.3934C27.8536 22.3934 28.3013 21.9456 28.3013 21.3934C28.3013 20.8411 27.8536 20.3934 27.3013 20.3934V22.3934ZM17.5013 27.0434C16.949 27.0434 16.5013 27.4911 16.5013 28.0434C16.5013 28.5956 16.949 29.0434 17.5013 29.0434V27.0434ZM27.3013 29.0434C27.8536 29.0434 28.3013 28.5956 28.3013 28.0434C28.3013 27.4911 27.8536 27.0434 27.3013 27.0434V29.0434ZM1.16797 2.44086H2.16797H1.16797ZM32.8546 1.44336V2.44336V1.44336ZM33.8346 2.44086H34.8346H33.8346ZM33.8346 33.6959H34.8346H33.8346ZM32.8546 34.6934V35.6934V34.6934ZM2.14797 34.6934V35.6934V34.6934ZM7.70155 28.0433H6.70155C6.70155 28.5956 7.14926 29.0433 7.70155 29.0433V28.0433ZM7.70155 21.3933V20.3933C7.14926 20.3933 6.70155 20.841 6.70155 21.3933H7.70155ZM10.9682 21.3933H11.9682C11.9682 20.841 11.5205 20.3933 10.9682 20.3933V21.3933ZM10.9682 28.0433V29.0433C11.5205 29.0433 11.9682 28.5956 11.9682 28.0433H10.9682ZM7.7013 9.09336H27.3013V7.09336H7.7013V9.09336ZM7.7013 15.7434H27.3013V13.7434H7.7013V15.7434ZM17.5013 22.3934H27.3013V20.3934H17.5013V22.3934ZM17.5013 29.0434H27.3013V27.0434H17.5013V29.0434ZM2.16797 33.6959V2.44086H0.167969V33.6959H2.16797ZM2.16797 2.44086C2.16797 2.43587 2.17008 2.43457 2.16834 2.43634L0.741668 1.0347C0.372354 1.41061 0.167969 1.91674 0.167969 2.44086H2.16797ZM2.16834 2.43634C2.16601 2.43872 2.15904 2.44336 2.14797 2.44336V0.443359C1.61707 0.443359 1.11157 0.65819 0.741668 1.0347L2.16834 2.43634ZM2.14797 2.44336H32.8546V0.443359H2.14797V2.44336ZM32.8546 2.44336C32.8436 2.44336 32.8366 2.43872 32.8343 2.43634L34.2609 1.0347C33.891 0.65819 33.3855 0.443359 32.8546 0.443359V2.44336ZM32.8343 2.43634C32.8325 2.43457 32.8346 2.43587 32.8346 2.44086H34.8346C34.8346 1.91674 34.6303 1.41061 34.2609 1.0347L32.8343 2.43634ZM32.8346 2.44086V33.6959H34.8346V2.44086H32.8346ZM32.8346 33.6959C32.8346 33.7008 32.8325 33.7021 32.8343 33.7004L34.2609 35.102C34.6302 34.7261 34.8346 34.22 34.8346 33.6959H32.8346ZM32.8343 33.7004C32.8366 33.698 32.8436 33.6934 32.8546 33.6934V35.6934C33.3855 35.6934 33.891 35.4785 34.2609 35.102L32.8343 33.7004ZM32.8546 33.6934H2.14797V35.6934H32.8546V33.6934ZM2.14797 33.6934C2.15904 33.6934 2.16601 33.698 2.16834 33.7004L0.741668 35.102C1.11157 35.4785 1.61707 35.6934 2.14797 35.6934V33.6934ZM2.16834 33.7004C2.17008 33.7021 2.16797 33.7009 2.16797 33.6959H0.167969C0.167969 34.22 0.372354 34.7261 0.741668 35.102L2.16834 33.7004ZM8.70155 28.0433V21.3933H6.70155V28.0433H8.70155ZM7.70155 22.3933H10.9682V20.3933H7.70155V22.3933ZM9.96821 21.3933V28.0433H11.9682V21.3933H9.96821ZM10.9682 27.0433H7.70155V29.0433H10.9682V27.0433Z"
        fill="#C5CEE0"
      />
    </svg>
  )
}
const Add = (props) => {
  return (
    <svg
      {...props}
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.418 5.25H8.91797V0.75C8.91797 0.33525 8.5073 0 8.0013 0C7.4953 0 7.08464 0.33525 7.08464 0.75V5.25H1.58464C1.07864 5.25 0.667969 5.58525 0.667969 6C0.667969 6.41475 1.07864 6.75 1.58464 6.75H7.08464V11.25C7.08464 11.6648 7.4953 12 8.0013 12C8.5073 12 8.91797 11.6648 8.91797 11.25V6.75H14.418C14.924 6.75 15.3346 6.41475 15.3346 6C15.3346 5.58525 14.924 5.25 14.418 5.25Z"
        fill="#0095FF"
      />
    </svg>
  )
}
const Wp = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0H32V32H0V0Z" fill="#44C554" />
      <path
        d="M16.0334 7C18.1645 7.00112 20.1647 7.87831 21.6688 9.47057C23.1729 11.0628 24.0008 13.1794 24 15.43C23.9982 20.0283 20.4953 23.7781 16.165 23.8526L16.0336 23.8537H16.0303C14.7174 23.8533 13.4271 23.5105 12.2771 22.8595L12.2233 22.8287L8 24L9.13019 19.6346C8.43313 18.3573 8.06631 16.908 8.06688 15.4232C8.06863 10.7788 11.6424 7 16.0334 7ZM16.0361 8.42287C12.3838 8.42287 9.41337 11.5636 9.41194 15.424C9.41144 16.7267 9.75094 17.9962 10.3944 19.0992L10.4242 19.1501L10.5817 19.415L9.91281 21.9986L12.4189 21.3035L12.6607 21.4552C13.6611 22.0829 14.8057 22.42 15.9742 22.4309L16.0308 22.4311H16.0336C19.6831 22.4311 22.6534 19.2902 22.6549 15.4296C22.6556 13.5588 21.9676 11.7996 20.7174 10.4762C19.4672 9.15281 17.8047 8.42353 16.0361 8.42287ZM13.213 11.5332C13.3456 11.5332 13.4786 11.5345 13.5945 11.5408C13.7167 11.5471 13.8808 11.4917 14.0423 11.902C14.1043 12.0593 14.1986 12.3023 14.2951 12.5505L14.3158 12.6037C14.4711 13.0032 14.6263 13.4015 14.6562 13.4648C14.7059 13.5701 14.739 13.6931 14.6727 13.8335C14.6064 13.9741 14.5731 14.0618 14.4737 14.1848C14.3741 14.3076 14.2647 14.4593 14.1751 14.5535C14.1702 14.5586 14.1654 14.5638 14.1605 14.5689L14.146 14.5846C14.0573 14.6817 13.983 14.793 14.0879 14.9829C14.2039 15.1937 14.6034 15.8831 15.1951 16.4412C15.9554 17.1582 16.5969 17.3806 16.7959 17.486C16.9949 17.5913 17.1111 17.5737 17.2272 17.4331C17.3434 17.2927 17.7248 16.8186 17.8575 16.6079C17.9902 16.3972 18.1229 16.4324 18.3054 16.5026C18.3921 16.536 18.6588 16.6685 18.9361 16.8098L19.0224 16.8538C19.3001 16.9959 19.5709 17.1372 19.6655 17.1873C19.8646 17.2927 19.9973 17.3454 20.047 17.4331C20.0968 17.521 20.0967 17.9423 19.9309 18.434C19.7651 18.9257 18.9697 19.3744 18.5873 19.435C18.2444 19.489 17.8104 19.5116 17.3336 19.3516C17.0446 19.2544 16.6737 19.125 16.1987 18.9081C14.202 17.9965 12.8978 15.8703 12.7984 15.73L12.7916 15.7204C12.6703 15.549 11.9855 14.5675 11.9855 13.5525C11.9855 12.5166 12.4998 12.0074 12.6822 11.7966C12.8647 11.586 13.0803 11.5332 13.213 11.5332Z"
        fill="white"
      />
    </svg>
  )
}
const Remove = (props) => {
  return (
    <svg
      {...props}
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.54962 1.63334L5.17462 4.00001L7.54962 6.36667C7.70739 6.52314 7.79612 6.73614 7.79612 6.95834C7.79612 7.18054 7.70739 7.39353 7.54962 7.55001C7.39236 7.706 7.17946 7.79295 6.95796 7.79167C6.73645 7.79295 6.52356 7.706 6.36629 7.55001L3.99962 5.17501L1.63296 7.55001C1.47569 7.706 1.26279 7.79295 1.04129 7.79167C0.819788 7.79295 0.606889 7.706 0.449624 7.55001C0.291863 7.39353 0.203125 7.18054 0.203125 6.95834C0.203125 6.73614 0.291863 6.52314 0.449624 6.36667L2.82462 4.00001L0.449624 1.63334C0.238241 1.42196 0.155687 1.11386 0.233059 0.825107C0.31043 0.536354 0.535972 0.310812 0.824725 0.233441C1.11348 0.156069 1.42157 0.238624 1.63296 0.450006L3.99962 2.82501L6.36629 0.450006C6.57767 0.238624 6.88577 0.156069 7.17452 0.233441C7.46328 0.310812 7.68882 0.536354 7.76619 0.825107C7.84356 1.11386 7.76101 1.42196 7.54962 1.63334Z"
        fill="#7C7C7C"
      />
    </svg>
  )
}
export {
  Remove,
  Wp,
  Add,
  Journal,
  Teqvim,
  CalendarDark,
  Decrase,
  Dot,
  Increase,
  Document,
  Calculator,
  Calculator2,
  FullStar,
  EmptyStar,
  Book,
  Attention,
  Cancel,
  CalendarIcon,
  LibraryIcon,
  SlideArrowIcon,
  InstaIcon,
  CallCentre,
  Help,
  Timer,
  SmsOrange,
  WorkPlace,
  Work,
  Language,
  Plus,
  Education,
  Account,
  SlideArrow,
  Issue,
  Info,
  SearchIcon,
  Calendar,
  Map,
  LangArrows,
  Menu,
  Close,
  RightArrow,
  BackArrow,
  ButtonArrow,
  PlayIcon,
  CopyRight,
  fbIcon,
  liIcon,
  ytIcon,
  Article,
  Post,
  Eye,
  Clear,
  BreadcrumbArrow,
  Location,
  Clock,
  Call,
  Sms,
}
